// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InviteStyles .modal-content {
  border-radius: 30px;
  width: 700px;
  min-height: 593px;
  padding-left: 20px;
  padding-right: 20px;
  background-color: #fff !important;
}
.success-alert {
  background-color: white;
  color: black;
  min-height: 100px;
  /* Add any other styles you want to apply to the success alert */
}
.InviteStyles .title {
  font-size: 20px;
  font-weight: 700;
  display: flex;
  justify-content: space-between;
}
.InviteStyles .InvitationEmail {
  /* border:1px solid red; */
  width: 590px;
  margin: auto;
  margin-bottom: 20px;
}

.InviteStyles .InvitationEmail input {
  width: 100%;
  border-radius: 50px;
  border: 2px solid grey;
  font-size: 16px;
  padding: 11px;
}
.InviteStyles .InvitationSubject {
  width: 590px;
  margin: auto;
  margin-bottom: 20px;
}
.InviteStyles .InvitationSubject input {
  width: 100%;
  border-radius: 50px;
  border: 2px solid grey;
  font-size: 16px;
  padding: 11px;
}
.InviteStyles .InvitationTextaera {
  /* border:1px solid red; */
  width: 590px;
  margin: auto;
  margin-bottom: 20px;
}

.InviteStyles .InvitationTextaera textarea {
  width: 100%;
  border-radius: 20px;
  border: 2px solid #949494;
  font-size: 16px;
  padding: 11px;
}

.invite-align-parent {
  display: flex;
  justify-content: center;
}
.InviteStyles .Invite-align {
  width: 88px;
  height: 33px;
  border: none;
  border-radius: 20px;
  background-color: rgb(7, 55, 100);
  color: white;
  text-align: center;
  cursor: pointer;
}
/* .InviteStyles .Invite:disabled{
    width: 88px;
    height:33px;
    border:none;
    border-radius:20px; 
    background-color:#98B9D8 ;
    color:white;
    margin-left: 270px;
    cursor: pointer;
} */
.InviteStyles .Invite-align:disabled {
  width: 88px;
  height: 33px;
  border: none;
  border-radius: 20px;
  background-color: #98b9d8;
  color: white;
  cursor: pointer;
}

.InviteOptionsContainer_align {
  display: flex;
  justify-content: space-between;
}

.InviteStyles .Change {
  position: relative;
  padding: 10px;
  text-align: center;
  color: #e1e1e1;
}
.InviteStyles .Change::before {
  content: "";
  position: absolute;
  top: 22px;
  left: 8px;
  border: 1px solid #e1e1e1 !important;
  width: 240px !important;
  height: 2px;
}

.InviteStyles .Change::after {
  content: "";
  position: absolute;
  top: 22px;
  right: 8px;
  border: 1px solid #e1e1e1 !important;
  width: 240px !important;
  height: 2px;
}
.GmailContacts_align {
  /* margin-left: 60px; */
  width: 250px;
  height: 33px;
  border: none;
  border-radius: 20px;
  margin: auto;
  background-color: #f3f2f0;
}
.GmailContacts_align span {
  color: #3e90e1;
  font-weight: bold;
}

.FacebookContacts_align {
  /* margin-left: 30px; */
  width: 250px;
  height: 33px;
  border: none;
  margin: auto;
  border-radius: 20px;
  background-color: #f3f2f0;
}
.FacebookContacts_align span {
  color: #3e90e1;
  margin-left: 5px;
  font-weight: bold;
}

.InviteStyles .multipleEmail {
  background-color: #d4d5d6;
  display: inline-block;
  font-size: 14px;
  border-radius: 30px;
  height: 30px;
  padding: 0 4px 0 1rem;
  display: inline-flex;
  align-items: center;
  margin: 0.6rem 0.3rem 0.3rem 0.6rem;
}
.InviteStyles .multipleEmail > .button {
  background-color: white;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  border: none;
  cursor: pointer;
  font: inherit;
  margin-left: 10px;
  font-weight: bold;
  padding: 0;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}
label.mar-lft-1rem {
  margin-left: 1rem;
}

.InviteStyles .InviteMember,
.InviteStyles .InviteAllMembers {
  width: 590px;
  margin: auto;
}
.InviteStyles .InviteMember {
  margin-left: 20px;
}
.InviteStyles .SearchInput {
  border-bottom: 1px solid #e9ecef;
  margin-bottom: 20px;
  margin-left: -3%;
  margin-right: -3%;
}
.InviteStyles .userImg {
  width: 46px;
  height: 46px;
  border-radius: 50%;
  margin: 0 auto;
  margin-right: 10px;
}
.InviteStyles .MemberList {
  height: 340px;
  overflow-y: scroll;
  margin-bottom: 15px;
}
.InviteStyles .nodata {
  font-size: 1.6rem;
  display: flex;
  justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/Modules/home/Invitations/invitations.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,iCAAiC;AACnC;AACA;EACE,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,gEAAgE;AAClE;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,0BAA0B;EAC1B,YAAY;EACZ,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,aAAa;AACf;AACA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,aAAa;AACf;AACA;EACE,0BAA0B;EAC1B,YAAY;EACZ,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,iCAAiC;EACjC,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;AACA;;;;;;;;;GASG;AACH;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,oCAAoC;EACpC,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,oCAAoC;EACpC,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,mCAAmC;AACrC;AACA;EACE,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,iBAAiB;EACjB,iBAAiB;EACjB,UAAU;EACV,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,YAAY;EACZ,YAAY;AACd;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,uBAAuB;AACzB","sourcesContent":[".InviteStyles .modal-content {\r\n  border-radius: 30px;\r\n  width: 700px;\r\n  min-height: 593px;\r\n  padding-left: 20px;\r\n  padding-right: 20px;\r\n  background-color: #fff !important;\r\n}\r\n.success-alert {\r\n  background-color: white;\r\n  color: black;\r\n  min-height: 100px;\r\n  /* Add any other styles you want to apply to the success alert */\r\n}\r\n.InviteStyles .title {\r\n  font-size: 20px;\r\n  font-weight: 700;\r\n  display: flex;\r\n  justify-content: space-between;\r\n}\r\n.InviteStyles .InvitationEmail {\r\n  /* border:1px solid red; */\r\n  width: 590px;\r\n  margin: auto;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.InviteStyles .InvitationEmail input {\r\n  width: 100%;\r\n  border-radius: 50px;\r\n  border: 2px solid grey;\r\n  font-size: 16px;\r\n  padding: 11px;\r\n}\r\n.InviteStyles .InvitationSubject {\r\n  width: 590px;\r\n  margin: auto;\r\n  margin-bottom: 20px;\r\n}\r\n.InviteStyles .InvitationSubject input {\r\n  width: 100%;\r\n  border-radius: 50px;\r\n  border: 2px solid grey;\r\n  font-size: 16px;\r\n  padding: 11px;\r\n}\r\n.InviteStyles .InvitationTextaera {\r\n  /* border:1px solid red; */\r\n  width: 590px;\r\n  margin: auto;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.InviteStyles .InvitationTextaera textarea {\r\n  width: 100%;\r\n  border-radius: 20px;\r\n  border: 2px solid #949494;\r\n  font-size: 16px;\r\n  padding: 11px;\r\n}\r\n\r\n.invite-align-parent {\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n.InviteStyles .Invite-align {\r\n  width: 88px;\r\n  height: 33px;\r\n  border: none;\r\n  border-radius: 20px;\r\n  background-color: rgb(7, 55, 100);\r\n  color: white;\r\n  text-align: center;\r\n  cursor: pointer;\r\n}\r\n/* .InviteStyles .Invite:disabled{\r\n    width: 88px;\r\n    height:33px;\r\n    border:none;\r\n    border-radius:20px; \r\n    background-color:#98B9D8 ;\r\n    color:white;\r\n    margin-left: 270px;\r\n    cursor: pointer;\r\n} */\r\n.InviteStyles .Invite-align:disabled {\r\n  width: 88px;\r\n  height: 33px;\r\n  border: none;\r\n  border-radius: 20px;\r\n  background-color: #98b9d8;\r\n  color: white;\r\n  cursor: pointer;\r\n}\r\n\r\n.InviteOptionsContainer_align {\r\n  display: flex;\r\n  justify-content: space-between;\r\n}\r\n\r\n.InviteStyles .Change {\r\n  position: relative;\r\n  padding: 10px;\r\n  text-align: center;\r\n  color: #e1e1e1;\r\n}\r\n.InviteStyles .Change::before {\r\n  content: \"\";\r\n  position: absolute;\r\n  top: 22px;\r\n  left: 8px;\r\n  border: 1px solid #e1e1e1 !important;\r\n  width: 240px !important;\r\n  height: 2px;\r\n}\r\n\r\n.InviteStyles .Change::after {\r\n  content: \"\";\r\n  position: absolute;\r\n  top: 22px;\r\n  right: 8px;\r\n  border: 1px solid #e1e1e1 !important;\r\n  width: 240px !important;\r\n  height: 2px;\r\n}\r\n.GmailContacts_align {\r\n  /* margin-left: 60px; */\r\n  width: 250px;\r\n  height: 33px;\r\n  border: none;\r\n  border-radius: 20px;\r\n  margin: auto;\r\n  background-color: #f3f2f0;\r\n}\r\n.GmailContacts_align span {\r\n  color: #3e90e1;\r\n  font-weight: bold;\r\n}\r\n\r\n.FacebookContacts_align {\r\n  /* margin-left: 30px; */\r\n  width: 250px;\r\n  height: 33px;\r\n  border: none;\r\n  margin: auto;\r\n  border-radius: 20px;\r\n  background-color: #f3f2f0;\r\n}\r\n.FacebookContacts_align span {\r\n  color: #3e90e1;\r\n  margin-left: 5px;\r\n  font-weight: bold;\r\n}\r\n\r\n.InviteStyles .multipleEmail {\r\n  background-color: #d4d5d6;\r\n  display: inline-block;\r\n  font-size: 14px;\r\n  border-radius: 30px;\r\n  height: 30px;\r\n  padding: 0 4px 0 1rem;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  margin: 0.6rem 0.3rem 0.3rem 0.6rem;\r\n}\r\n.InviteStyles .multipleEmail > .button {\r\n  background-color: white;\r\n  width: 22px;\r\n  height: 22px;\r\n  border-radius: 50%;\r\n  border: none;\r\n  cursor: pointer;\r\n  font: inherit;\r\n  margin-left: 10px;\r\n  font-weight: bold;\r\n  padding: 0;\r\n  line-height: 1;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\nlabel.mar-lft-1rem {\r\n  margin-left: 1rem;\r\n}\r\n\r\n.InviteStyles .InviteMember,\r\n.InviteStyles .InviteAllMembers {\r\n  width: 590px;\r\n  margin: auto;\r\n}\r\n.InviteStyles .InviteMember {\r\n  margin-left: 20px;\r\n}\r\n.InviteStyles .SearchInput {\r\n  border-bottom: 1px solid #e9ecef;\r\n  margin-bottom: 20px;\r\n  margin-left: -3%;\r\n  margin-right: -3%;\r\n}\r\n.InviteStyles .userImg {\r\n  width: 46px;\r\n  height: 46px;\r\n  border-radius: 50%;\r\n  margin: 0 auto;\r\n  margin-right: 10px;\r\n}\r\n.InviteStyles .MemberList {\r\n  height: 340px;\r\n  overflow-y: scroll;\r\n  margin-bottom: 15px;\r\n}\r\n.InviteStyles .nodata {\r\n  font-size: 1.6rem;\r\n  display: flex;\r\n  justify-content: center;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
